import { ResultItem } from '@/store/types/resultTypes';
import { RESULT_TEMPLATES } from '@/components/features/result/ResultTemplates/types';

/**
 * Обрабатывает массив результатов: добавляет id и проставляет template=default если не передан
 */
export const processResultsWithTemplates = (results: ResultItem[]): ResultItem[] => {
	return results.map((result, index) => ({
		...result,
		text: result.text || '',
		template: result.template ?? RESULT_TEMPLATES.DEFAULT,
		id: result.id ?? index,
	}));
};
